import { ElevionLeafNode, ElevionNode } from './elevion.types';

export const isLeafNode = (node: ElevionNode): node is ElevionLeafNode => {
  return 'comparator' in node;
};
